/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_Error_TitleInputs */

const en_portalframe_error_title = /** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This did not load`)
};

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const ar_portalframe_error_title = en_portalframe_error_title;

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const he_portalframe_error_title = en_portalframe_error_title;

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const ur_portalframe_error_title = en_portalframe_error_title;

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const es_portalframe_error_title = en_portalframe_error_title;

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const fr_portalframe_error_title = en_portalframe_error_title;

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const de_portalframe_error_title = en_portalframe_error_title;

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const pt_portalframe_error_title = en_portalframe_error_title;

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const hi_portalframe_error_title = en_portalframe_error_title;

/** @type {(inputs: Portalframe_Error_TitleInputs) => LocalizedString} */
const bn_portalframe_error_title = en_portalframe_error_title;

/**
* | output |
* | --- |
* | "This did not load" |
*
* @param {Portalframe_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_error_title = /** @type {((inputs?: Portalframe_Error_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Error_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_error_title(inputs)
	if (locale === "he") return he_portalframe_error_title(inputs)
	if (locale === "ur") return ur_portalframe_error_title(inputs)
	if (locale === "es") return es_portalframe_error_title(inputs)
	if (locale === "fr") return fr_portalframe_error_title(inputs)
	if (locale === "de") return de_portalframe_error_title(inputs)
	if (locale === "pt") return pt_portalframe_error_title(inputs)
	if (locale === "hi") return hi_portalframe_error_title(inputs)
	if (locale === "bn") return bn_portalframe_error_title(inputs)
	return /** @type {LocalizedString} */ ("This did not load")
});